module.exports = (__webpack_require__(0))(441)


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/core-js/modules/es6.string.ends-with.js from dll-reference polyfills_lib
// module id = 376
// module chunks = 2